export const TRACKING_VERSION = '1';

export const ALL_TRACKERS = [{ name: 'prod', trackingId: 'UA-72193832-1' }];

export const NULL_VALUE = '(not set)';

export const DIMENSIONS = {
  USER_EMAIL: 'dimension1',
  TRACKING_VERSION: 'dimension2',
  CLIENT_ID: 'dimension3',
  WINDOW_ID: 'dimension4',
  HIT_ID: 'dimension5',
  HIT_TIME: 'dimension6',
  HIT_TYPE: 'dimension7',
  HIT_SOURCE: 'dimension8',
  VISIBILITY_STATE: 'dimension9',
  URL_QUERY_PARAMS: 'dimension10',
};

export const METRICS = {
  RESPONSE_END_TIME: 'metric1',
  DOM_LOAD_TIME: 'metric2',
  WINDOW_LOAD_TIME: 'metric3',
  PAGE_VISIBLE: 'metric4',
  MAX_SCROLL_PERCENTAGE: 'metric5',
  PAGE_LOADS: 'metric6',
};
